import React, { Component } from 'react';

import CircularProgress from 'material-ui/CircularProgress';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_es_ES from '@amcharts/amcharts4/lang/es_ES'

class EvapoPre extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxs: [],
      visible: false,
    };
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        maxs: this.props.maxs,
      });
      this.loadChart();
    }, 10500);
  }

  loadChart = () => {
    if (this.props.data_diaria) {
      for (const diaria of this.props.data_diaria) {
        const fechaData = new Date(diaria.fecha);
        
        diaria.pre = 0;

        for ( const data of this.props.data ) {
          const fecha = new Date(data.fecha);
        
          if (fechaData.getDate() === fecha.getDate() && fechaData.getMonth() === fecha.getMonth() && fechaData.getFullYear() === fecha.getFullYear()) {
            diaria.pre += parseFloat(data.pre);
          }
        }

        diaria.balance = diaria.pre + diaria.evapo;
      }
    }

    this.setState({
      visible: true,
    });

    const chart = am4core.create("evapo_pre", am4charts.XYChart);
    chart.zoomOutButton.disabled = true;
    chart.language.locale = am4lang_es_ES;


    // console.log(this.props.data_diaria);
    chart.data = this.props.data_diaria;

    // Set input format for the dates
    chart.dateFormatter.inputDateFormat = "yyyy-MM-dd";

    // Create axes
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.groupData = true;
    dateAxis.renderer.grid.template.disabled = true;
    dateAxis.baseInterval = {
      "timeUnit": "day",
      "count": 1
    };
    dateAxis.dateFormatter.dateFormat = "dd-MM-yyyy";
    dateAxis.renderer.minGridDistance = 60;
    dateAxis.dateFormats.setKey("month", "MMM");
    dateAxis.periodChangeDateFormats.setKey("month", "[bold]MMM");
    dateAxis.dateFormats.setKey("day", "MMM dd");
    dateAxis.periodChangeDateFormats.setKey("day", "[bold]MMM");
    dateAxis.dateFormats.setKey("hour", "HH:mm");
    dateAxis.periodChangeDateFormats.setKey("hour", "[bold]MMM dd[/]");
    dateAxis.dateFormats.setKey("minute", "HH:mm");
    dateAxis.periodChangeDateFormats.setKey("minute", "[bold]MMM dd[/]");
    dateAxis.keepSelection = true;
    dateAxis.start = 0.6;

    const buttonContainer = chart.plotContainer.createChild(am4core.Container);
    buttonContainer.shouldClone = false;
    buttonContainer.align = "right";
    buttonContainer.valign = "top";
    buttonContainer.zIndex = 100;
    buttonContainer.marginTop = 0;
    buttonContainer.marginRight = 5;
    buttonContainer.layout = "horizontal";

    const zoomInButton = buttonContainer.createChild(am4core.Button);
    zoomInButton.label.text = "+";
    zoomInButton.events.on("hit", function (ev) {
      const diff = dateAxis.maxZoomed - dateAxis.minZoomed;
      const delta = diff * 0.2;
      dateAxis.zoomToDates(new Date(dateAxis.minZoomed + delta), new Date(dateAxis.maxZoomed - delta));
    });

    const zoomOutButton = buttonContainer.createChild(am4core.Button);
    zoomOutButton.label.text = "-";
    zoomOutButton.events.on("hit", function (ev) {
      dateAxis.zoomToIndexes(dateAxis.startIndex, dateAxis.endIndex);
    });

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = "mm";
    valueAxis.title.fontSize = 14;
    valueAxis.title.rotation = 0;
    valueAxis.keepSelection = true;
    valueAxis.extraMax = 0.2;
    valueAxis.extraMin = 0.1;
    valueAxis.start = 0.1;

    // Create series
    function createSeries(field, name, color) {
      const series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = field; 
      series.clustered = false;
      series.dataFields.dateX = "fecha";
      series.name = name;
      series.strokeWidth = 2;
      series.minBulletDistance = 10;
      series.stroke = am4core.color(color);
      series.fill = am4core.color(color);
      series.showOnInit = false;
    }

    const serieEvapo = 'Evapotranspiración';
    const seriePrecitacion = 'Precipitación';
    const serieFake = 'BALANCE';

    createSeries("evapo", serieEvapo, "#F78447");
    // createSeries("pre", seriePrecitacion, "#3983D9");
    createSeries("pre", seriePrecitacion, "#3983D9")

    // Make a panning cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.behavior = "zoomX";
    chart.cursor.xAxis = dateAxis;
    chart.cursor.lineY.disabled = true;
    valueAxis.cursorTooltipEnabled = false;

    // Create container to hold our hover labels
    const info = chart.chartContainer.createChild(am4core.Container);
    info.width = 250;
    info.layout = "absolute";
    info.toBack();
    info.marginBottom = 15;
    info.paddingLeft = 10;
    info.x = 0;
    info.y = 0;
    info.zIndex = 100;
    info.background.fill = am4core.color("#000");
    info.background.fillOpacity = 0;
    info.layout = "grid";

    // Create labels
    function createLabel(title, color, serieFake = "") {
      const titleLabel = info.createChild(am4core.Label);
      titleLabel.text = `${title}:`;
      titleLabel.marginRight = 5;
      titleLabel.minWidth = 130;
      titleLabel.fontWeight = "bolder";
      titleLabel.fill = color;
      titleLabel.textAlign = "end";

      const valueLabel = info.createChild(am4core.Label);
      valueLabel.id = title;
      valueLabel.text = "-";
      valueLabel.minWidth = 80;
      valueLabel.fontWeight = "bolder";
      valueLabel.fill = color;

      if (serieFake) {
        const serieFakeTitle = info.createChild(am4core.Label);
        serieFakeTitle.text = `${serieFake}:`;
        serieFakeTitle.marginRight = 5;
        serieFakeTitle.minWidth = 130;
        serieFakeTitle.fontWeight = "bolder";
        serieFakeTitle.fill = am4core.color("#000");
        serieFakeTitle.textAlign = "end";

        const serieFakeValue = info.createChild(am4core.Label);
        serieFakeValue.id = serieFake;
        serieFakeValue.text = "-";
        /* serieFakeValue.minWidth = 80; */
        serieFakeValue.fontWeight = "bolder";
        serieFakeValue.fill = am4core.color("#000");
      }
    }

    chart.series.each((series) => {
      const nameFake = series.name === seriePrecitacion ? serieFake : "";
      createLabel(series.name, series.stroke, nameFake);
    });

    // Set up number format
    chart.numberFormatter.numberFormat = "###.#";

    // Show last item by default
    chart.events.on("ready", () => {
      chart.series.each((series) => {
        updateValues(series.dataItems.last, series.name, serieFake);
      });
    });

    // Show overal close values when cursor is not shown
    chart.cursor.events.on("hidden", () => {
      chart.series.each((series) => {
        updateValues(series.dataItems.last, series.name, serieFake);
      });
    });

    // Set up cursor's events to update the label
    chart.cursor.events.on("cursorpositionchanged", () => {
      chart.series.each((series) => {
        const dataItem = dateAxis.getSeriesDataItem(
          series,
          dateAxis.toAxisPosition(chart.cursor.xPosition),
          true
        );
        updateValues(dataItem, series.name, serieFake);
      });
    });

    // Updates values
    function updateValues(dataItem, key, serieFake) {
      chart.series.each(() => {
        if (!!dataItem) {
          const label = chart.map.getKey(key);
          const text = !!dataItem["valueY"] ? `${chart.numberFormatter.format(Math.abs(dataItem["valueY"]))} mm` : '- mm';
          label.text  = text;
  
          const labelBalance = chart.map.getKey(serieFake);
          
          if (labelBalance) {
            labelBalance.text = `${chart.numberFormatter.format(dataItem.dataContext.balance)} mm`;
          }
        }
      });
    }
  };

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  render() {
    if (this.state.visible) {
      return (
        <div id="evapo_pre" style={{padding: '0'}} />
      );
    }
    return (
      // <div><h3>Cargando...</h3></div>
      <div style={{ position: 'relative', width: '100%', height: 'auto', padding: '10px', margin: 'auto auto' }}>
        <CircularProgress color={'#819eff'} size={200} thickness={10} value={70} />
      </div>
    );
  }
}

export default EvapoPre;



// WEBPACK FOOTER //
// ./src/charts/EvapoPre.js